<template>
  <div class="home">
    <div class="banner">
      <img
        :src="homeBanner"
        v-if="bannerFlag"
        alt=""
      />
      <video v-else :autoplay="true" :loop="true" muted :src="videoMp4"></video>
    </div>

    <!-- 核心业务 -->
    <div class="core">
      <div class="typeArea">
        <!-- 统一版心 -->
        <div class="coreTop">
          <div class="coreTop-Img">
            <img src="../../public/skypegmwcn_imgs/sky/advantage.png" alt="" />
          </div>
          <h4>盘石核心业务及优势</h4>
        </div>
        <!--  -->
        <div class="coreMain ram">
          <div class="coreMain_Left">
            <div>
              <img
                src="../../public/skypegmwcn_imgs/sky/newsshili.png"
                alt=""
              />
              <ul>
                <li>
                  <p>标注质量高</p>
                </li>
                <li>
                  <p>人员经验丰富</p>
                </li>
                <li>
                  <p>成功案例积累</p>
                </li>
              </ul>
            </div>
            <!--  -->
            <div class="coreMain_font">
              <h3>为百强企业提供全流程数据标注、模型训练</h3>
              <div>
                <p>
                  值得信赖的权威数据标注平台，提供高标准、高质量的数据清洗及数据标注服务，可以根据客户的业务需求定制标注工具，生成高质量的训练数据，为智能AI数据标注、智慧校园、物联网等提供解决方案的科技公司
                </p>
                <div class="btn">
                  <a
                    href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN"
                    target="_blank"
                    >合作咨询</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="coreMain_rigth">
            <div class="coreMain_font fontR">
              <h3>专业的数据标注学习培训</h3>
              <div>
                <p>
                  国内多位顶级人工智能专家，倾情打造专业课程，详实的理论课程+海量实操习题助你扬帆数据时代。
                </p>
                <div class="btn">
                  <a
                    href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN"
                    target="_blank"
                    >合作咨询</a
                  >
                </div>
              </div>
            </div>
            <img src="../../public/skypegmwcn_imgs/sky/yewu2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="real ram">
      <div>
        <div class="real_Top title">
          <img src="../../public/skypegmwcn_imgs/sky/application.png" alt="" />
          <h4>真实业务落地场景</h4>
        </div>
        <div class="real_main">
          <ul>
            <li>
              <img
                src="../../public/skypegmwcn_imgs/sky/zidongjiashi1.png"
                alt=""
              />
              <div>
                <p>自动驾驶领域</p>
                <span>智能汽车领域广泛应用的语义分割 语音转写等标注体系</span>
              </div>
            </li>
            <li>
              <img
                src="../../public/skypegmwcn_imgs/sky/zhinengjiaju1.png"
                alt=""
              />
              <div>
                <p>智能家具领域</p>
                <span>智能家居领域广泛应用的声音转写 实体等标注体系</span>
              </div>
            </li>
            <li>
              <img
                src="../../public/skypegmwcn_imgs/sky/zhinengjiqiren1.png"
                alt=""
              />
              <div>
                <p>智能机器人领域</p>
                <span
                  >智能机器人领域广泛应用的事件关系 问答对标注等标注体系</span
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 多语言 -->
    <div class="langue ram">
      <div class="typeArea">
        <div class="langue_Top">
          <img
            src="../../public/skypegmwcn_imgs/sky/ServiceSolution.png"
            alt=""
          />
          <h4>多语言数据服务解决方案</h4>
          <p>为 算 法 模 型 应 用 落 地 保 驾 护 航</p>
        </div>
        <div class="langue_tabs">
          <div>
            <ul class="langue_Ul">
              <li
                @click="isTab(i)"
                :class="{ active: index == i }"
                v-for="(item, i) in Tabs"
                :key="item.id"
              >
                <div>
                  <img :src="item.icon" alt="" />
                  <p>
                    {{ item.characters }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="langue_tabs_main">
            <div>
              <div
                class="langue_List"
                @click="site = i"
                :class="{ pitch: site == i }"
                v-for="(ite, i) in Tabs[index].children"
                :key="ite.id"
              >
                <div>
                  <p>{{ ite.text }}</p>
                  <img
                    class="List_img"
                    src="../../public/skypegmwcn_imgs/sky/duoyuyan/computer.png"
                    alt=""
                  />
                  <img :src="ite.cImg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main_bott">
          <a href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN" target="_blank"
            >闲余时间，轻松赚钱，兼职入口 <span>→</span></a
          >
        </div>
      </div>
    </div>
    <!-- 培训解决方案 -->
    <div class="train ram">
      <div class="typeArea">
        <div class="train_Top">
          <img
            src="../../public/skypegmwcn_imgs/sky/Trainingsolution.png"
            alt=""
          />
          <h4>培训解决方案</h4>
          <p>独 立 研 发 的 专 业 数 据 标 注 学 习 系 统</p>
        </div>
        <div class="train_main">
          <div>
            <img src="../../public/skypegmwcn_imgs/sky/peixun.png" alt="" />
          </div>
          <div class="train_main_rigth">
            <h4>盘石数据标注学习平台</h4>
            <p>
              盘石数据立志打造培训—认证—就业—培训—就业升级的全流程体系；
              解决行业技能培训无法落地的痛点，优秀学员可<span
                >直接录取入职, 进入高薪行业</span
              >
            </p>
            <div>
              <a href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN" target="_blank"
                >院校合作入口 <span> →</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="collaborate ram" v-if="1>2">
      <div class="typeArea">
        <div>
          <div class="collaborate_Top">
            <img src="../../public/skypegmwcn_imgs/sky/partners.png" alt="" />
            <h4>合作伙伴</h4>
          </div>
          <div class="collaborate_main">
            <ul>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/2.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/110.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/4.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/5.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/6.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/7.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/8.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/9.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/10.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/11.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/13.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/14.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/15.png"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="../../public/skypegmwcn_imgs/sky/hezuo/16.png"
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 商务合作 -->
    <div class="business ram">
      <div class="typeArea">
        <div>
          <div class="business_Top">
            <img
              src="../../public/skypegmwcn_imgs/sky/cooperation.png"
              alt=""
            />
            <h4>商务合作</h4>
          </div>
          <ul class="business_main">
            <li>
              <img src="../../public/skypegmwcn_imgs/sky/01.png" alt="" />
              <img src="../../public/skypegmwcn_imgs/xuanzhong/04.png" alt="" />
              <div @mouseover="onMou" @mouseout="noMou">
                <img :src="onImg" alt="" />
                <h3>企业级数据标注业务</h3>
                <p>多类型标注支持、高准确率、一站式服务流程</p>
                <p>可同时进行多类别数据服务及AI上下游企业</p>
                <div class="isShow">
                  <p>
                    <a
                      href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN"
                      target="_blank"
                      >企业合作咨询</a
                    >
                  </p>
                  <p>
                    <a
                      href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN"
                      target="_blank"
                      >招代理合作</a
                    >
                  </p>
                </div>
              </div>
            </li>
            <li>
              <img v="-" src="../../public/skypegmwcn_imgs/sky/02.png" alt="" />
              <img src="../../public/skypegmwcn_imgs/xuanzhong/05.png" alt="" />
              <div @mouseover="isMou" @mouseout="IsMou">
                <img :src="onImgA" alt="" />
                <h3>数据标注培训</h3>
                <p>多位名校实力教授倾情打造的标注实训课程</p>
                <p>改变现有生活，拿到进入高薪行业通行证</p>
                <p>人社部第三方培训评价组织机构共建合作</p>
                <div class="isShow">
                  <p class="business_ten">
                    <a
                      href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN"
                      target="_blank"
                      >代理合作</a
                    >
                  </p>
                  <p class="business_ten">
                    <a
                      href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN"
                      target="_blank"
                      >专业共建</a
                    >
                  </p>
                  <p class="business_ten">
                    <a
                      href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN"
                      target="_blank"
                      >我要报名</a
                    >
                  </p>
                </div>
              </div>
            </li>
            <li>
              <img src="../../public/skypegmwcn_imgs/sky/03.png" alt="" />
              <img src="../../public/skypegmwcn_imgs/xuanzhong/06.png" alt="" />
              <div @mouseover="isMou(2)" @mouseout="IsMou(2)">
                <img :src="onImgB" alt="" />
                <h3>数据标注人员兼职</h3>
                <p>数千万企业级项目、专业的标注培训</p>
                <p>让您在闲暇时间赚得盆满钵满</p>
                <div class="isShow">
                  <p>
                    <a
                      href="https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN"
                      target="_blank"
                      >立即沟通</a
                    >
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 新闻咨询 -->
    <div class="news" v-if="jouList">
      <div class="typeArea">
        <div>
          <div class="news_Top">
            <img src="../../public/skypegmwcn_imgs/sky/news.png" alt="" />
            <h4>新闻资讯</h4>
          </div>
          <div class="news_main">
            <!-- Swiper -->
            <el-carousel class="newsSwiper" trigger="click" height="450px">
              <el-carousel-item v-for="item in listFlag" :key="item.id">
                <!-- <h3 class="small">{{ item.text }}</h3> -->
                <img class="news_img" :src="item.blogImg" alt="" />
              </el-carousel-item>
            </el-carousel>

            <div class="newsText">
              <el-tooltip :content="listFlag[0].title" placement="top">
                <h3 class="text-ellipsis">{{ listFlag[0].title }}</h3>
              </el-tooltip>
              <span class="spanLeft">{{ listFlag[0].gmtCreate }}</span>
              <p class="fullText">
                {{ listFlag[0].summary }}
                <span class="full" @click="AddFullText(listFlag[0].id)"
                  >查看全文 <span class="el-icon-right"></span
                ></span>
              </p>
              <div class="seeAll">
                <p>
                  <router-link target="_blank" to="/journalism"
                    >查看全部</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // imgList:require('../../public/skypegmwcn_imgs/sky/'),
      index: 0,
      site: 0,
      isLoading:false,
      flag: true,
      isFlagA: false,
      isFlagB: true,
      isFlagC: true,
      bannerFlag: true,
      list: [],
      listFlag: [],
      jouList: false,
      videoMp4: require("../../public/skypegmwcn_imgs/xuanzhong/2月7日.mp4"),
      onImg: require("../../public/skypegmwcn_imgs/sky/qiyeji.png"),
      onImgA: require("../../public/skypegmwcn_imgs/sky/shujupeixun.png"),
      onImgB: require("../../public/skypegmwcn_imgs/sky/jianzhi.png"),
      Tabs: [
        {
          id: 2,
          icon: require("../../public/skypegmwcn_imgs/sky/text.png"),
          characters: "文本",
          children: [
            {
              id: 1,
              text: "分词词性",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/fencicixing.png"),
            },
            {
              id: 2,
              text: "分类",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/fenlei.png"),
            },
            {
              id: 3,
              text: "关键词",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/guanjianci.png"),
            },
            {
              id: 4,
              text: "关系",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/guanxi.png"),
            },
            {
              id: 5,
              text: "命名实体",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/mingmingshiti.png"),
            },
            // {
            //   id: 6,
            //   text: "事件",
            //   cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/shijian.png"),
            // },
            {
              id: 7,
              text: "事件实体",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/shijianshiti.png"),
            },
            {
              id: 8,
              text: "实体关系",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/shitiguanxi.png"),
            },
            {
              id: 9,
              text: "SQL",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/SQL.png"),
            },
            // {
            //   id: 10,
            //   text: "文本匹配",
            //   cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/wenbenpipei.png"),
            // },
            {
              id: 11,
              text: "问答",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/wenben/wendadui.png"),
            },
          ],
        },
        {
          id: 1,
          icon: require("../../public/skypegmwcn_imgs/sky/tuxiang.png"),
          characters: "图像",
          children: [
            {
              id: 1,
              text: "2d拉框",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/tuxiang/2D.png"),
            },
            {
              id: 2,
              text: "语义分割",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/tuxiang/yuyifenge.png"),
            },
             {
              id: 3,
              text: "3D点云",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/tuxiang/3Ddianyun.png"),
            },
          ],
        },
        {
          id: 3,
          icon: require("../../public/skypegmwcn_imgs/sky/yuyin.png"),
          characters: "语音",
          children: [
            {
              id: 1,
              text: "语音切割转写",
              cImg: require("../../public/skypegmwcn_imgs/sky/duoyuyan/yuyin/yuyinqiegezhuanxie.png"),
            },
          ],
        },
      ],
    };
  },
  methods: {
    setbanner() {
      // gif首屏加载问题
      // setTimeout(() => {
      //   this.bannerFlag = false;
      // }, 500);
    },
    redirect() {
      window.navigator("https://webchat-bj.clink.cn/chat.html?accessId=40a698b9-ff15-49f3-a24a-994158dfc69e&language=zh_CN");
    },
    // 全局3d
    isHome() {
      this.$parent.isRam();
    },
    // 选项卡
    isTab(i) {
      this.index = i;
      this.site = 0;
    },
    AddFullText(id) {
      this.$router.push({
        path: "/detailPage",
        query: { id: id },
      });
    },
    onMou() {
      this.isFlagA = false;
      this.onImg = require("../../public/skypegmwcn_imgs/xuanzhong/qiyeji2.png");
    },
    noMou() {
      this.isFlagA = true;
      this.onImg = require("../../public/skypegmwcn_imgs/sky/qiyeji.png");
    },
    isMou(type) {
      if (type != 2) {
        this.isFlagB = false;
        this.onImgA = require("../../public/skypegmwcn_imgs/xuanzhong/shujupeixun2.png");
      }
      if (type == 2) {
        this.isFlagC = false;
        this.onImgB = require("../../public/skypegmwcn_imgs/xuanzhong/jianzhi2.png");
      }
    },
    IsMou(type) {
      if (type != 2) {
        this.isFlagB = true;
        this.onImgA = require("../../public/skypegmwcn_imgs/sky/shujupeixun.png");
      }
      if (type == 2) {
        this.isFlagC = true;
        this.onImgB = require("../../public/skypegmwcn_imgs/sky/jianzhi.png");
      }
    },
    getList() {
      this.$axios
        .post("/apis/community/api/panshi/blog/list", {
          statusId: 1,
          pageCurrent: this.currentPage,
          pageSize: this.pagesize,
        })
        .then((res) => {
          this.jouList = true;
          this.nub = res.data.data.totalCount;
          this.list = res.data.data.list;
          this.listFlag = this.list.splice(0, 3);
          console.log(this.listFlag);
        })
        .catch((res) => {
          this.jouList = false;
        });
    },
  },
  mounted() {
    document.title = "盘石数据";

    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      this.jouList = true;
      let nav = document.querySelector(".navgit");
      let navList = document.querySelector(".navList");
      nav.style.transform = " translateX(350px)";
      let arrList = document.querySelectorAll(".ram");
      arrList.forEach((ele) => {
        ele.classList.remove("ram");
      });
    } else {
      this.setbanner();
    }
    setTimeout(() => {
      this.getList();
      this.isLoading = true
    }, 1000);
  },
  computed: {
    isList() {
      return document.querySelectorAll(".ram");
    },
    isfull() {
      return document.querySelector(".fullText");
    },
    homeBanner() {
      if(this.isLoading){
        return require("../../public/skypegmwcn_imgs/sky/bannerlinshizhanwei.webp");
      }else{
        return require("../../public/skypegmwcn_imgs/sky/bannerlinshizhanwei_new-loading.webp");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 版心 */
.typeArea {
  width: 1664px;
  height: 300px;
  margin: 0 auto;
}
// gif图片
.banner {
  width: 100vw;
  height: 800px;
  img {
    height: 800px;
    margin: 0 auto;
  }
}
video {
  width: 99vw;
  height: 800px;
  margin: 0 auto;
}

.main {
  height: 2000px;
  margin: 200px;
}
.main_flag {
  transition: 1s;
  width: 300px;
  height: 300px;
  background: pink;
}

/* core核心业务 */

.core {
  height: 1350px;
  margin-top: 100px;
  width: 99vw;
  .coreTop {
    margin-bottom: 100px;

    h4 {
      font-size: 42px;
      transform: translateY(-45px);
    }
    img {
      margin: 0 auto;
    }
  }
  .coreMain {
    img {
      // width: 40vw;
      margin-right: 20px;
    }
    .btn {
      width: 208px;
      line-height: 60px;
      color: white;
      border-radius: 30px;
      font-size: 24px;
      cursor: pointer;
      height: 60px;
      margin-top: 78px;
      background-image: linear-gradient(#ff8a00, #ffc242);
    }
    ul {
      transform: translateY(-50px);
      display: flex;
      margin-left: 20px;
      margin-right: 32px;
      justify-content: space-between;
      li {
        font-size: 24px;
        color: #ff8a00;
        background: rgba(255, 255, 255, 0.8);
        line-height: 100px;
        width: 212px;
        font-weight: 500;
        font-family: Microsoft YaHei;
        height: 100px;
        box-shadow: 7px 10px 27px 0px rgba(0, 0, 0, 0.08);
        border-radius: 32px;
      }
    }
    .coreMain_Left {
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    .coreMain_rigth {
      display: flex;
      justify-content: space-between;
    }
    .coreMain_font {
      margin-top: 60px;
      width: 42vw;
      h3 {
        text-align: left;
        margin-left: 5px;
        font-size: 36px;
        margin-bottom: 48px;
      }
      p {
        text-align: left;
        font-size: 24px;
        line-height: 44px;
      }
    }
    .fontR {
      h3 {
        text-align: right;
      }
      p {
        text-align: right;
      }
      .btn {
        float: right;
      }
    }
  }
}

/* real 真实业务*/

.real {
  width: 99vw;
  margin-bottom: 150px;
  .real_Top {
    margin: 0 auto;
    img {
      margin: 0 auto;
    }
    h4 {
      font-size: 42px;
      transform: translateY(-45px);
    }
  }
  .real_main {
    width: 99vw;
    margin: 0 auto;
    ul {
      color: white;
      padding-left: -1vw;
      padding-right: -1vw;
      /* margin: 0 auto; */
      display: flex;
      align-items: center;
      justify-content: center;
      li {
        overflow: hidden;
        position: relative;
        div {
          width: 100%;
          height: 100%;
          text-align: center;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-5%);
        }
        p {
          font-size: 36px;
          color: white;
          transform: translateY(-20px);
        }
        span {
          display: block;
          margin-top: 40px;
          font-size: 24px;
          margin-left: 140px;
          margin-right: 140px;
          transform: translateY(-20px);
          opacity: 0;
          transition: all 1s;
        }
      }
      img {
        width: 100%;
        transition: all 1s;
      }

      li:hover img {
        transform: scale(1.2);
      }
      li:hover span {
        opacity: 1;
      }
    }
  }
}

/* langue */

.langue {
  width: 99vw;
  height: 1200px;
  margin-bottom: 150px;
  .langue_Top {
    h4 {
      font-size: 42px;
      transform: translateY(-45px);
    }
    p {
      font-size: 20px;
      transform: translateY(-25px);
    }
    img {
      margin: 0 auto;
    }
    margin-bottom: 55px;
  }
  .langue_tabs {
    .langue_Ul {
      margin: 0 auto;
      width: 448px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #d2d2d7;

      li {
        transform: translateY(1px);
        // transition: all 1s;
        img {
          border-radius: 15px;
        }
      }
      .active {
        border-bottom: 2px solid #ffc242;
        padding-bottom: 20px;
        color: #ffc242;
        p {
          transition: all 1s;
        }
        img {
          transform: translateY(-10px);
          box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
          transition: all 1s;
        }
      }
    }
  }
  .langue_tabs_main {
    transform: translateY(55px);
    width: 1500px;
    margin: 0 auto;
    display: flex;
    position: relative;
    height: 850px;
    .langue_List {
      margin-left: 100px;
      box-sizing: border-box;
      margin-bottom: 12px;
      border-radius: 25px;
      font-size: 20px;
      line-height: 48px;
      height: 48px;
      div {
        display: flex;
      }
      img {
        display: none;
        position: absolute;
        top: 55px;
        left: 550px;
      }
      p {
        width: 208px;
        height: 48px;
        border: 1px solid #d2d2d7;
        border-radius: 25px;
      }
      .List_img {
        display: block;
        position: absolute;
        top: 0;
        left: 400px;
        z-index: -1;
      }
    }
    .pitch {
      background: #ff8a00;
      color: white;
      p {
        border: none;
      }
      img {
        display: block;
      }
    }
  }
}
.main_bott {
  position: relative;
  z-index: 2;
  font-size: 20px;
  width: 544px;
  height: 60px;
  margin: 0 auto;
  line-height: 60px;
  color: white;
  border-radius: 30px;
  cursor: pointer;
  text-align: center;
  background-image: linear-gradient(#ffc242, #ff8a00);
  span {
    color: white;
    font-size: 24px;
    line-height: 46px;
    margin-left: 10px;
  }
}

/* train */

.train {
  width: 99vw;
  height: 800px;
  background: #fafafa;
  .train_Top {
    padding-top: 100px;
    h4 {
      font-size: 42px;
      transform: translateY(-45px);
    }
    p {
      font-size: 20px;
      transform: translateY(-25px);
    }
    img {
      margin: 0 auto;
    }
    margin-bottom: 55px;
  }
  .train_main {
    width: 1500px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    font-weight: 300;

    .train_main_rigth {
      font-size: 20px;
      text-align: left;
      margin-left: 128px;
      h4 {
        font-size: 36px;
        margin-bottom: 48px;
      }
      span {
        color: #ff8a00;
        line-height: 44px;
      }
      p {
        line-height: 44px;
      }
      div {
        margin-top: 78px;
        width: 320px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: white;
        border-radius: 30px;
        font-size: 24px;
        cursor: pointer;
        background: linear-gradient(0deg, #ff8a00, #ffc242);
        span {
          color: white;
          padding-bottom: 2px;
        }
      }
    }
  }
}

.collaborate {
  width: 99vw;
  height: 500px;
  background: #fafafa;
  padding-top: 100px;
  .collaborate_Top {
    h4 {
      font-size: 42px;
      transform: translateY(-45px);
    }
    img {
      margin: 0 auto;
    }
    margin-bottom: 55px;
  }
  .collaborate_main {
    width: 1664px;
    margin: 0 auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      li {
        margin-top: 15px;
      }
    }
  }
}

/* business */
.business {
  padding-top: 100px;
  width: 99vw;
  height: 1000px;
  .business_Top {
    h4 {
      font-size: 42px;
      transform: translateY(-45px);
    }
    img {
      margin: 0 auto;
    }
    margin-bottom: 55px;
  }
  .business_main {
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 600px;
    li {
      height: 600px;
      position: relative;
      margin-right: 15px;
      width: 100%;
      overflow: hidden;
      > img {
        margin: 0 auto;
        margin-bottom: 50px;
        transition: all 1s;
        overflow: hidden;
      }
      img {
        margin: 0 auto;
        margin-bottom: 50px;
        transition: all 1s;
        overflow: hidden;
      }
      > div {
        width: 100%;
        position: absolute;
        top: 100px;
        left: 0;
        margin: 0 auto;
        h3 {
          font-size: 36px;
          margin-bottom: 30px;
        }
        p {
          font-family: Microsoft YaHei;
          font-size: 20px;
          margin-bottom: 20px;
        }

        .isShow {
          margin-top: 60px;
          width: 100%;
          display: flex;
          justify-content: space-around;
          p {
            cursor: pointer;
            // display: none;
            transition: all 1s !important;
            opacity: 0;
            width: 208px;
            height: 60px;
            background: linear-gradient(0deg, #ff8a00, #ffc242);
            border-radius: 30px;
            text-align: center;
            color: white;
            line-height: 60px;
          }
          .business_ten {
            width: 160px;
          }
        }
      }
    }
    li:hover .isShow p {
      // display: block;
      opacity: 1;
    }
    li:hover > img {
      transform: translateY(-100%);
    }
    li:hover {
      color: white;
    }
  }
}

/* news */
.news {
  width: 99vw;
  height: 800px;
  .news_Top {
    h4 {
      font-size: 42px;
      transform: translateY(-45px);
    }
    img {
      margin: 0 auto;
    }
    margin-bottom: 55px;
  }
  .news_main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      display: -webkit-box;
    }
    h3 {
      // height: 36px;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #1d1d1f;
      // line-height: 21px;
      text-align: left;
    }
    .spanLeft {
      display: block;
      text-align: left;
      height: 15px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #1d1d1f;
      line-height: 44px;
      margin-bottom: 50px;
    }
    .newsText {
      margin-left: 5vw;
      width: 90vw;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #1d1d1f;
      line-height: 44px;
      text-align: left;
      .full {
        height: 23px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #ff8a00;
        line-height: 21px;
        cursor: pointer;
      }
    }
    .seeAll {
      width: 208px;
      height: 60px;
      background: linear-gradient(0deg, #ff8a00, #ffc242);
      border-radius: 30px;
      cursor: pointer;
      p {
        height: 24px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 58px;
        text-align: center !important;
        display: block;
        margin-top: 86px;
      }
    }
  }
}

//  适配
@media all and (min-width: 1600px) {
  .banner {
    width: 100%;
    img {
      margin: 0 auto;
      width: 100%;
    }
  }
}

@media all and(max-width:1664px) {
  html,
  body {
    width: 1920px;
  }
  video {
    width: 1910px;
  }
  .real_Top {
    width: 1664px;
  }
  .core {
    padding-top: 100px;
    height: 1500px;
    width: 1600px !important;
    margin: 0 auto;
  }
  .core_Main {
    margin: 0 auto;
    width: 1600px !important;
  }
  .coreMain_font {
    min-width: 500px;
  }
  .real_main {
    width: 1600px;
    ul {
      width: 1600px;
      margin: 0 auto;
      img {
        width: 33%;
      }
    }
  }
}

/* swiper */
.el-carousel {
  width: 1200px !important;
  border-radius: 22px;
  img {
    width: 100%;
    height: 100%;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-backtop {
  position: relative;
  z-index: 999;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 900px;
}
</style>
